import { render, staticRenderFns } from "./ServiceValueList.vue?vue&type=template&id=4236106b"
import script from "./ServiceValueList.vue?vue&type=script&lang=js"
export * from "./ServiceValueList.vue?vue&type=script&lang=js"
import style0 from "./ServiceValueList.vue?vue&type=style&index=0&id=4236106b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports